import axios from "infra/http";
import { useQuery } from "react-query";
import { VotacaoPerguntaEstatisticaDetalhesDto } from "../typings";

function useDetalhesPergunta(votacaoId: string, perguntaId: string) {
  return useQuery(
    `/v1/votacao/${votacaoId}/pergunta/${perguntaId}`,
    async () => {
      const res = await axios.get<VotacaoPerguntaEstatisticaDetalhesDto>(
        `/v1/votacao/${votacaoId}/pergunta/${perguntaId}`
      );

      return res.data;
    },
    {
      enabled: !!votacaoId && !!perguntaId,
    }
  );
}

export default useDetalhesPergunta;
